import React from "react";
import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import ComponentCard from "../Common/ComponentCard";
import RouteControlledEntityCreateModal from "./RouteControlledEntityCreateModal";


class RouteControlledEntityInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            entities: null
        };
    }

    async componentDidMount() {
        await this.retrieveEntities();
    }

    async retrieveEntities(){
        const url = 'route_controlled_entity/';
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                route: this.props.route.id
            }
        );
        this.setState(
            {
                entities: response.data.results
            }
        );
    }

    render() {
        if (!this.state.entities){
            return (
                <CircularProgress/>
            )
        }
        return(
            <Stack>
                <RouteControlledEntityCreateModal
                    route={this.props.route}
                    callBack={this.retrieveEntities.bind(this)}
                />
                {
                    this.state.entities.map(
                        (each) => (
                            <ComponentCard
                                key={'ComponentCard'+each.entity+each.entity_id}
                                entity={each.entity}
                                entity_id={each.entity_id}
                            />
                        )
                    )
                }
            </Stack>
        )
    }
}

export default RouteControlledEntityInner